const {h, render, Component} = require('preact');
const queryString = require('qs')
const ItemsListContainer = require('./items_list')
const InfiniteScrollContainer = require('../common/infinite_scroll')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const SpinnerView = require('../../views/common/spinner')

class Items extends Component {
  constructor(props) {
    super(props)
    this.state = {
      itemsLoading: false,
      isLoadingInProgress: true,
      items: [],
    }
    this.getItems = this.getItems.bind(this)
  }

  componentWillMount() {
    this.getItems(0);
  }

  getItems(page) {
    this.fetchItems(page);
  }

  getItemsUrl(page) {
    let baseUrl = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}`
    let queryParams = {page: page || 0}
    if (this.props.pageType == 'orders') {
      baseUrl = baseUrl + '/user/orders'
      queryParams = Object.assign(queryParams, {sort_attribute: 'purchased_at', sort_order: 'descending'})
    }
    else
      baseUrl = baseUrl + '/claims'
    let qs = queryString.stringify(queryParams)
    let itemsUrl = baseUrl + "?" + qs
    return itemsUrl
  }

  fetchItems(page) {
    let itemsUrl = this.getItemsUrl(page)
    let errorCb = (response) => {
      this.setState((state, props) => {
        // In-case of failure, dont remove the existing view and also continue scrolling from the failed page
        let newState = Object.assign({}, state)
        newState['items'] = newState['items']
        newState['page'] = page - 1
        newState['itemsLoading'] = true
        newState['isLoadingInProgress'] = false
        return newState
      });
    }
    let successCb = (response) => {
      if (response) {
        if (this.props.pageType == 'orders')
          response.items = response.orders
        else
          response.items = response.claims

        this.setState((state, props) => {
          let newState = Object.assign({}, state)
          newState['items'] = newState['items'].concat(response.items)
          newState['page'] = page
          newState['itemsLoading'] = (response.pagination.count > newState['items'].length)
            && (response.pagination.count > response.pagination.offset) &&
            (response.items.length > 0)
          newState['isLoadingInProgress'] = false
          return newState
        });
      }
    }
    this.setState({'isLoadingInProgress':true})
    SupportAPIHelper.get(itemsUrl, null, successCb, errorCb, false);
  }

  render() {
    let itemsListContainer = null
    if (this.state.items && this.state.items.length > 0) {
      itemsListContainer = <ItemsListContainer items={this.state.items} isLoadingInProgress={this.state.isLoadingInProgress} pageType={this.props.pageType}/>
      return (
        <InfiniteScrollContainer loadMore={this.getItems} hasMore={this.state.itemsLoading && !this.state.isLoadingInProgress}
                                 currentPage={this.state.page}>
          {itemsListContainer}
        </InfiniteScrollContainer>
      )
    }
    return <SpinnerView/>
  }
}

module.exports = Items
